(() => {
  const root = document.querySelector('.cx-full-home');
  const office = root?.querySelector('#office-sequence');
  const data = root?.querySelector('[data-office-frames]');
  if (!office || !data) return;
  const urls = JSON.parse(data.textContent);
  const frame = office.querySelector('.office-frame');
  const progressBar = office.querySelector('.office-progress span');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const loaded = new Map();
  const pending = new Set();
  let queue = [], running = 0, target = 0, displayed = -1, near = false, ticking = false;
  const enabled = () => !motion.matches;
  function paint() {
    if (!enabled()) return;
    const choices = [...loaded.keys()];
    if (!choices.length) return;
    const closest = choices.reduce((a,b) => Math.abs(a-target) <= Math.abs(b-target) ? a : b);
    if (closest !== displayed) { frame.src = urls[closest]; displayed = closest; office.dataset.frame = String(closest+1); }
  }
  function pump() {
    if (!enabled() || !near) return;
    while (running < 4 && queue.length) {
      const i = queue.shift();
      if (loaded.has(i) || pending.has(i)) continue;
      pending.add(i); running++;
      const img = new Image(); img.decoding = 'async';
      const finish = ok => { running--; pending.delete(i); if(ok) loaded.set(i,img); paint(); pump(); };
      img.onload = () => finish(true); img.onerror = () => finish(false); img.src = urls[i];
    }
  }
  function update() {
    ticking = false;
    if (!enabled()) return;
    const rect = office.getBoundingClientRect();
    const height = office.querySelector('.office-sticky').offsetHeight;
    const travel = Math.max(1, office.offsetHeight-height);
    const progress = Math.max(0,Math.min(1,-rect.top/travel));
    target = Math.round(progress*(urls.length-1));
    progressBar.style.transform = `scaleY(${progress})`;
    if (near) {
      queue = Array.from({length:urls.length},(_,i)=>i).filter(i=>!loaded.has(i)&&!pending.has(i)).sort((a,b)=>Math.abs(a-target)-Math.abs(b-target));
      pump(); paint();
    }
  }
  const schedule = () => { if (!ticking) { ticking=true; requestAnimationFrame(update); } };
  function setMode() {
    office.classList.toggle('office-ready',enabled());
    if (!enabled()) { frame.src=urls[0]; office.dataset.frame='1'; queue=[]; displayed=-1; }
    else schedule();
  }
  setMode(); motion.addEventListener('change',setMode);
  if ('IntersectionObserver' in window) {
    const observer=new IntersectionObserver(entries=>{near=entries[0].isIntersecting;if(near)schedule();},{rootMargin:'1200px 0px'});
    observer.observe(office);
  } else {near=true;schedule();}
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
})();
